import { callAgroApi } from '@services/agroapi';
export const withTemplates = () => ({
  actions: {
    createTemplate(templateData: {
      name: string;
      tasks: Array<{
        activity_type_id: string | null;
        dap: number | null;
        note: string;
      }>;
    }, orgId: string) {
      return callAgroApi(`/organizations/${orgId}/templates`, 'POST', templateData);
    },
    updateTemplate(templateData: {
      name: string;
      tasks: Array<{
        activity_type_id: string | null;
        dap: number | null;
        note: string;
      }>;
    }, templateId: string) {
      return callAgroApi(`/templates/${templateId}`, 'PATCH', templateData);
    },
    deleteTemplate(templateId: string) {
      return callAgroApi(`/templates/${templateId}`, 'DELETE');
    }
  }
});